import { ChangeEvent } from 'react';
import { FormRenderProps } from 'react-final-form';
import { action } from 'typesafe-actions';
import { FormApi } from 'final-form';

import { IUploadFile } from 'CorePackage/MainModule/interfaces/IUploadFile';

import { IFeedbackForm } from '../interfaces/IFeedbackForm';
import { FeedbackActionsEnum } from '../enums/FeedbackActionsEnum';
import { IFeedbackKnmData } from '../interfaces/IFeedbackKnmData';

export const feedbackPost =
  (values: IFeedbackForm, textDescription: string, form?: FormRenderProps<IFeedbackForm>['form']) => () =>
    action(FeedbackActionsEnum.FEEDBACK_POST, { values, textDescription, form });
export const feedbackUploadFile = (e: ChangeEvent<HTMLInputElement>, nameIfExists: string) =>
  action(FeedbackActionsEnum.FEEDBACK_UPLOAD_FILE, { e, nameIfExists });
export const feedbackSetFiles = (files: IUploadFile[]) => action(FeedbackActionsEnum.FEEDBACK_SET_FILES, { files });
export const feedbackSetForm = (form: FormApi<IFeedbackForm, Partial<IFeedbackForm>>) =>
  action(FeedbackActionsEnum.FEEDBACK_SET_FORM, { form });
export const feedbackReset = () => action(FeedbackActionsEnum.FEEDBACK_RESET);
export const feedbackSetKnmData = (knmData: IFeedbackKnmData) =>
  action(FeedbackActionsEnum.FEEDBACK_SET_KNM_DATA, { knmData });
